import React, { useLayoutEffect,useState  } from "react";
import { Blurhash } from "react-blurhash";

import Program from "../Components/Reuseable/Program";
import image from "../assets/images/group/players.jpg";
import { useGlobalContext } from "../Context";

const playerHeaderHash = "L6Hfec9t}fM|dSo4Izsn.nV?E|Rk"

export default function Players() {
  const { setNav, player } = useGlobalContext();
  const [loaded, setLoaded] = useState(false);

  // Function to handle image load event
  const handleImageLoad = () => {
    setLoaded(true);
  };

  useLayoutEffect(() => {
    setNav(true);
    document.title = "Beyond Limits Football Academy Players";
  }, [setNav]);
  return (
    <>
     <header>
        {!loaded && (
          <div
            className="Coaches"
          >
            <Blurhash
              hash={`${playerHeaderHash}`}
              width="100%"
              height="100%"
              resolutionX={32}
              resolutionY={32}
              punch={1}
            />
          </div>
        )}
        <img
           src={image}
          alt="Players"
          className={`${loaded?"block": "hidden"} Coaches`}
          onLoad={handleImageLoad}
        />
      </header>
   
      <section className="Players">
        <div className="container">
          <p className="Players__title Staff__title">
            beyond limits football academy players
          </p>
          <div className="Players__category">
            <div className="Players__title__container">
              <p className="Players__title">goal keeper</p>
            </div>

            <div className="grid sm:grid-cols-3 items-center">
              {player
                .filter((item) => item.categories[0].title === "keeper")
                .map((item, index) => {
                  return (
                    <div className="w-full sm:w-[80%] lg:w-full mx-auto" key={item._id}>
                    <Program item={item} />
                  </div>
                  );
                })}
            </div>
          </div>
          <div className="Players__category">
            <div className="Players__title__container">
              <p className="Players__title">defenders</p>
            </div>
            <div className="grid sm:grid-cols-3 items-center">
              {player
                .filter((item) => item.categories[0].title === "defence")
                .map((item, index) => {
                  return (
                    <div className="w-full sm:w-[80%] lg:w-full mx-auto" key={item._id}>
                      <Program item={item} />
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="Players__category">
            <div className="Players__title__container">
              <p className="Players__title">midfielders</p>
            </div>
            <div className="grid sm:grid-cols-3 items-center">
              {player
                .filter((item) => item.categories[0].title === "midfield")
                .map((item, index) => {
                  return (
                   
                     <div className="w-full sm:w-[80%] lg:w-full mx-auto" key={item._id}>
                     <Program item={item} />
                   </div>
                  );
                })}
            </div>
          </div>
          <div className="Players__category">
            <div className="Players__title__container">
              <p className="Players__title">forwards</p>
            </div>

            <div className="grid sm:grid-cols-3 items-center">
              {player
                .filter((item) => item.categories[0].title === "forward")
                .map((item, index) => {
                  return (
                    <div className="w-full sm:w-[80%] lg:w-full mx-auto" key={item._id}>
                      <Program item={item} />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
